/* eslint-disable react-hooks/exhaustive-deps */
import Button from "@mui/material/Button";
import "./onHandDeliveryEntry.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TextField from "@mui/material/TextField";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import { useDispatch, useSelector } from "react-redux";
import { FieldArray, FormikProvider, useFormik } from "formik";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { checkPro } from "./../../API/checkPro";
import Loader from "./../../components/loader/loader";
import { PopoutNotification } from "./../../AppState/popoutNotification";
import NOTIFICATION_TYPE from "./../../AppState/NotificationType";
import {
  CHECK_DIGIT_FIELDS,
  DType,
  EOnHandDeliveryStatus,
  EUploadKey,
} from "./../../constants";
import {
  compareObjects,
  excludeKeys,
  handleKeyDown,
  handleNumberMaxLength,
  handlePaste,
  replaceZerosWithUndefinedDeep,
  trimStrings,
  userTerminal,
  isPartiallyCleared,
} from "./../../helpers";
import { debounce } from "lodash";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { IOnHandEntry, IpartyDetails } from "../../models/onHandDelivery";
import { isFormValueChanged } from "../../AppState/isFormValueChanged";
import { ICheckDigitPro } from "../../models/osd";
import UploadDocument from "../../components/uploadDocument/uploadDocument";
import {
  terminalValuesSelector,
  terminalWithNameSelector,
} from "../../AppState/selectors";
import { InitOnHandFormValue, OnHandSchema } from "../../schema/onHandDelivery";
import { GetOnHandDetailsAPI } from "../../API/getOnHandDetailsAPI";
import dayjs from "dayjs";
import { CreateOnHandEntryAPI } from "../../API/createOnHandEntry";
import { OnHandResendAPI } from "../../API/onHandResendAPI";
import moment from "moment";
import TooltipWithClickAway from "../../components/terminalPicker/TooltipWithClickAway";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NoteBox from "../../components/noteBox/NoteBox";
import { GetPartialRefusalAPI } from "../../API/getPartialRefusal";
import { IDamage } from "../../models/prException";
import OnHandDeliveryInvestigation from "./onHandDeliveryInvestigation";
import OnHandFollowup from "./onHandFollowup";
import OnHandResend, { ResendFormValues } from "./onHandResend";
import { hasOhFollowUpSelector, hasOhInvestigationSelector } from "../../AppState/selectors/userPermissionsSelectors";
import { useTerminalMaster } from "../../@hooks/useTerminalMaster";
import { CommodityField } from "../../components/shared/form";
import PageHeaderWithBack from "../../components/PageHeaderWithBack";
import { useDateTimeFormatter } from "../../@hooks/useDateTimeFormatter";
import { useAccordionExpand } from "../../@hooks/useAccordionExpand";
import {
  FORM_STYLES,
  M_GRID_PROPS,
  S_GRID_PROPS,
  XL_GRID_PROPS,
} from "../../constants";
import ClearedInstructionDetails from "../../components/cleared/clearedInstructionDetails";

function OnHandDeliveryEntry() {
  const dispatch = useDispatch();
  const params = useParams();
  const exceptionNumber = params?.osdNumber;
  const location = useLocation();
  const damageOsdNumber = location.state?.osdNumber;

  // get terminal master from redux state
  let terminalOptions: string[] = useSelector(terminalValuesSelector);
  const hasOhInvestigationPermission = useSelector(hasOhInvestigationSelector);
  const hasOhFollowupPermission = useSelector(hasOhFollowUpSelector);
  const { loadTerminals } = useTerminalMaster();

  let terminalWithNameOptions: {
    terminalId: string;
    terminalName: string | undefined;
  }[] = useSelector(terminalWithNameSelector);
  const [ownership, setOwnership] = useState<{
    entryBy?: string;
    assignedTo?: string;
  } | null>(null);
  const [newIndex, setNewIndex] = useState<number | null>(null);
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [proCheckDError, setProCheckDError] = React.useState<boolean>(false);
  const [expanded, setExpanded] = React.useState<string[]>(["panel1"]); // handle expand page using "expanded" variable
  // set Initial value of All Shortage entry form
  const [isEditFormValuePatched, setIsEditFormValuePatched] =
    React.useState<string>("");
  const initValue: any = InitOnHandFormValue;
  initValue["reporting"] = userTerminal();
  const [initialFormValue, setInitialFormValue] =
    React.useState<any>(initValue);

  const [formFieldsDisabled, setFormFieldsDisabled] = React.useState<boolean>(
    Boolean(exceptionNumber),
  );
  const [formKey, setFormKey] = useState<string>(Date.now().toString());
  const [osdNumber, setOsdNumber] = React.useState<number | undefined>(
    exceptionNumber ? Number(exceptionNumber) : undefined,
  );
  const [osdDetails, setOsdDetails] = React.useState<IOnHandEntry>();
  const [updatedDateTime, setUpdatedDateTime] = React.useState<string>("");
  const formatShortageDateTime = useDateTimeFormatter(setUpdatedDateTime);

  const [investigationStatus, setInvestigationStatus] =
    React.useState<number>();
  const [editFormValueChanged, setEditFormValueChanged] =
    React.useState<boolean>(false);
  const [open, setOpen] = React.useState<boolean>(false);
  const [dateKey, setDateKey] = React.useState<string>(Date.now().toString());
  const isCleared = osdDetails?.clearedInstructionDetails?.cleared;
  const isPartiallyClearedStatus = isPartiallyCleared(osdDetails?.clearedInstructionDetails) && 
    (investigationStatus === EOnHandDeliveryStatus.needsCleared);
  const handleDateChange =
    (fieldName: string) => (value: dayjs.Dayjs | null) => {
      if (value?.format("MM/DD/YY") === "Invalid Date") {
        setDateKey(Date.now().toString());
      } else {
        setFieldValue(fieldName, value?.format("MM/DD/YYYY"), true);
        setOpen(false);
      }
    };

  const [inputValues, setInputValues] = React.useState<any>({
    iTerminal: undefined,
    iInputTerminal: undefined,
    cInputValue: undefined,
  });

  const [isOpenPopup, setIsOpenPopup] = React.useState<boolean>(false);
  const [proInfoAddButtonDisabled, setProInfoAddButtonDisabled] =
    useState(false);
  const [resetTimestamps, setResetTimestamps] = useState<string>(
    Date.now().toString(),
  );

  const updateInputValue = (key: string, value: any) => {
    setInputValues((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleAutoCompleteOnChange = (value: any, type?: DType) => {
    if (!value) {
      return;
    }
    if (type === DType.commodity) {
      setFieldValue("commodityCode", value?.code);
    } else {
      updateInputValue("iTerminal", value);
      setFieldValue("replyToTerminalNumber", value?.terminalId);
      setFieldValue("replyToPhoneNumber", value?.localTelephone);
      setFieldValue("replyToFaxNumber", value?.fax);
      setFieldValue("replyToAddress1", value?.terminalAddress1);
      setFieldValue("replyToAddress2", value?.terminalAddress2);
      setFieldValue("replyToCity", value?.terminalCity);
      setFieldValue("replyToZip", value?.terminalZip);
      setFieldValue("replyToState", value?.terminalState);
    }
  };

  const onAutoInputChange = (value: string, type?: DType) => {
    if (
      value === "undefined" ||
      (!["replyToTerminalNumber", "commodityCode"].includes(
        document?.activeElement?.id ?? "",
      ) &&
        value === undefined)
    )
      return;
    if (type === DType.commodity) {
      updateInputValue("cInputValue", value);
    } else {
      updateInputValue("iInputTerminal", value);
    }
  };

  // Initialize On Hand Delivery entry form using formik and pass validation schema and initial values
  // handle all form event and submit form using formik

  const form = useFormik({
    validationSchema: OnHandSchema,
    validateOnChange: false,
    initialValues: initValue,
    // Submit the form if all form fields are validated
    onSubmit: (_values) => {
      if (!editFormValueChanged) return;
      if (proCheckDError) {
        document.getElementsByName("proNumber")[0].focus();
        return;
      }

      setIsOpenPopup(true);
    },
  });

  const createOnHandEntry = () => {
    if (Object.keys(errors).length > 0) {
      return;
    }
    setIsOpenPopup(false);
    const reqInput = prepareRequestParams();
    delete reqInput["exceptionNumber"];
    setPageLoading(true);
    CreateOnHandEntryAPI(reqInput)
      .then((response: any) => {
        const { investigationStatusNumber, exceptionNumber } = response;
        setPageLoading(false);
        if (exceptionNumber) {
          setInitialFormValue(values);
          setExpanded(["panel1", "panel2"]);
          setInvestigationStatus(investigationStatusNumber);
          viewOnHandDeliveryEntry(exceptionNumber);
          setOsdNumber(exceptionNumber);
          setFormFieldsDisabled(true);
          dispatch(
            PopoutNotification(
              NOTIFICATION_TYPE.SUCCESS,
              `OS&D # ${exceptionNumber}  has been created successfully`,
              Date.now().toString(),
            ),
          );
        } else {
          dispatch(
            PopoutNotification(
              NOTIFICATION_TYPE.ERROR,
              "On Hand entry creation failed",
              Date.now().toString(),
            ),
          );
        }
      })
      .catch((err: any) => {
        setPageLoading(false);
        dispatch(
          PopoutNotification(
            NOTIFICATION_TYPE.ERROR,
            err ?? "On Hand Delivery entry creation failed",
            Date.now().toString(),
          ),
        );
      });
  };

  const {
    values,
    errors,
    handleChange,
    handleBlur,
    touched,
    handleSubmit,
    setFieldValue,
    resetForm,
    isSubmitting,
    validateField,
    validateForm,
    setFieldTouched,
    submitCount,
  } = form;

  const partyEmails = useMemo(
    () =>
      (values.partyDetails ?? [])
        .map((p: IpartyDetails) => p.partyEmail?.trim())
        .filter((email: string): email is string => !!email),
    [values.partyDetails],
  );

  const isSaved = (): boolean => {
    return Boolean(isKnownStatus);
  };

  const hasErrors = (fieldKey: string): boolean => {
    return Boolean(
      get(errors, `${fieldKey}`, "") && get(touched, `${fieldKey}`, ""),
    );
  };

  const prepareRequestParams = () => {
    let reqInput = structuredClone(values);
    const deleteFields = [
      "origin",
      "destination",
      "shipper",
      "shipperAccount",
      "shipperAddress",
      "shipperCity",
      "shipperState",
      "shipperZip",
      "consignee",
      "consigneeAccount",
      "consigneeAddress",
      "consigneeCity",
      "consigneeState",
      "consigneeZip",
      "ilScac",
      "thirdPartyName",
      "thirdPartyAddress1",
      "thirdPartyAddress2",
      "thirdPartyCity",
      "thirdPartyState",
      "thirdPartyZip",
    ];

    const fieldsToParse = [
      "proNumber",
      "weight",
      "pieces",
      "copiesToPrint",
      "lastManifestNumber",
      "replyToPhoneNumber",
    ];

    fieldsToParse.forEach((field) => {
      if (reqInput[field] && !Number.isNaN(reqInput[field])) {
        reqInput[field] = Number.parseInt(reqInput[field]);
      } else {
        reqInput[field] = 0;
      }
    });

    if (reqInput["copiesToPrint"] === 0) {
      reqInput["copiesToPrint"] = 1; // Default to 1 if copiesToPrint is 0
    }

    if (reqInput["storageChargeStartDate"]) {
      reqInput["storageChargeStartDate"] = moment(
        reqInput["storageChargeStartDate"],
        "MM/DD/YYYY",
      ).format("MMDDYYYY");
    } else {
      reqInput["storageChargeStartDate"] = "0";
    }

    reqInput["partyDetails"] = reqInput.partyDetails.map(
      (detail: IpartyDetails) => ({
        ...detail,
        partyFax:
          detail.partyFax && !Number.isNaN(detail.partyFax)
            ? Number(detail.partyFax)
            : 0,
      }),
    );

    deleteFields.forEach((f: string) => {
      delete reqInput[f];
    });
    reqInput["commodityCode"] = reqInput["commodityCode"]?.trim();
    reqInput["exceptionType"] = "OH";
    return trimStrings(reqInput);
  };

  // get Commodity code option master
  const getMasters = (ParamString: string) => {
    if (ParamString === "terminalMaster") {
      loadTerminals();
    }
  };

  const isKnownStatus = useMemo(() => {
    return (
      investigationStatus !== undefined &&
      Object.values(EOnHandDeliveryStatus).includes(investigationStatus)
    );
  }, [investigationStatus]);

  const shouldShowOnHandResend = useMemo(() => {
    if (!osdNumber || !investigationStatus) return false;

    return true;
  }, [osdNumber, investigationStatus]);

  // Check if followup section should be hidden
  const isFollowupEmpty = useMemo(() => {
    if (!osdDetails?.followup) return true;
    return Object.values(osdDetails.followup).every(
      (val) => val === undefined || val === null || val === ""
    );
  }, [osdDetails?.followup]);

  const shouldHideFollowup = useMemo(() => {
    return (
      investigationStatus === EOnHandDeliveryStatus.needsCleared &&
      isFollowupEmpty
    );
  }, [investigationStatus, isFollowupEmpty]);

  // Handler for resending on-hand notice
  const handleOnHandResend = React.useCallback(
    async (data: ResendFormValues) => {
      if (!osdNumber) return;

      setPageLoading(true);
      try {
        const response = await OnHandResendAPI({
          exceptionNumber: osdNumber,
          email1: data.email1?.trim() || undefined,
          email2: data.email2?.trim() || undefined,
          email3: data.email3?.trim() || undefined,
          email4: data.email4?.trim() || undefined,
          reason: data.reason,
        });

        if(response.message?.trim().toUpperCase().includes("SUCCESS")){
          dispatch(
            PopoutNotification(
              NOTIFICATION_TYPE.SUCCESS,
              `Notice resent successfully for OS&D # ${osdNumber}`,
              Date.now().toString(),
            ),
          );
        } else {
          dispatch(
            PopoutNotification(
              NOTIFICATION_TYPE.INFO,
              `Unable to resend the notice for OS&D #${osdNumber} because the required PDF file is not available.`,
              Date.now().toString(),
            ),
          );
          setPageLoading(false);
          return
        }

        // Refresh the details to get updated resend history
        GetOnHandDetailsAPI(osdNumber)
          .then((response: any) => {
            setPageLoading(false);
            if (response) {
              setOsdDetails(response);
            }
          })
          .catch(() => {
            setPageLoading(false);
            // Silently fail on refresh
          });
      } catch (error: any) {
        setPageLoading(false);
        dispatch(
          PopoutNotification(
            NOTIFICATION_TYPE.ERROR,
            error ?? "Failed to resend notice",
            Date.now().toString(),
          ),
        );
        throw error; // Re-throw to let the form handle the error state
      }
    },
    [osdNumber, dispatch],
  );

  // validate pro check digit via API if get pro details proD is valid otherwise not valid and show validation message
  const validateProCheckD = async (pro?: number | string | null) => {
    if (!pro) return;
    try {
      const checkProResponse = await checkPro(pro.toString());
      if (isEmpty(checkProResponse)) {
        setProCheckDError(true);
      } else {
        setProCheckDError(false);
      }

      patchProDetails(checkProResponse);
    } catch (error) {
      console.error("Error validating PRO number:", error);
      patchProDetails({});
      setProCheckDError(true);
    }
  };

  // patch pro details value with OV type got the values from proNumber API as above validateProCheckD method
  const patchProDetails = (checkProResponse: ICheckDigitPro) => {
    const fields: Array<keyof ICheckDigitPro> = CHECK_DIGIT_FIELDS;
    fields.forEach((f: keyof ICheckDigitPro) => {
      const fieldValue = checkProResponse[f];
      setFieldValue(
        f,
        typeof fieldValue === "string" ? fieldValue.trim() : (fieldValue ?? ""),
      );
    });
  };

  // set form value on exception type changed
  const reset = () => {
    setProCheckDError(false);
    document.getElementsByName("reporting")[0].focus();
    resetForm();

    setResetTimestamps(Date.now().toString());
    setFormKey(Date.now().toString());
    updateInputValue("iTerminal", undefined);
    updateInputValue("iInputTerminal", undefined);
    updateInputValue("cType", undefined);
    updateInputValue("cInputValue", undefined);
  };

  // Handle accordion expand (now using custom hook)
  const handleAccordionChange = useAccordionExpand({
    osdNumber,
    expanded,
    setExpanded,
    setFormFieldsDisabled,
    reset,
  });

  const patchEditFormValues = (onHandDelivery: any) => {
    const fields = Object.keys(InitOnHandFormValue);
    onHandDelivery = replaceZerosWithUndefinedDeep(onHandDelivery);
    fields.forEach((field: string) => {
      if (
        field === "partyDetails" &&
        (!onHandDelivery[field] || onHandDelivery[field]?.length === 0)
      ) {
        onHandDelivery[field] = [
          { partyEmail: undefined, partyFax: undefined },
        ];
      }
      const val =
        typeof onHandDelivery[field] === "string"
          ? onHandDelivery[field]?.trim() || ""
          : onHandDelivery[field];
      setFieldValue(field, val || "");
    });

    if (
      terminalWithNameOptions &&
      terminalWithNameOptions.length > 0 &&
      onHandDelivery?.replyToTerminalNumber
    ) {
      updateInputValue(
        "iTerminal",
        terminalWithNameOptions?.find(
          (d: any) =>
            d?.terminalId?.trim() === onHandDelivery?.replyToTerminalNumber,
        ),
      );
      updateInputValue("iInputTerminal", onHandDelivery?.terminalId);
    } else {
      updateInputValue("iTerminal", null);
      updateInputValue("iInputTerminal", undefined);
    }
    setIsEditFormValuePatched(Date.now().toString());
  };

  const viewOnHandDeliveryEntry = (
    osdId: number | string | undefined,
    flag: string = "",
  ) => {
    if (osdId) {
      // get AS entry and set form fields
      setPageLoading(true);
      GetOnHandDetailsAPI(osdId)
        .then((onHandDelivery: IOnHandEntry) => {
          formatShortageDateTime(onHandDelivery.entry);
          validateProCheckD(onHandDelivery.entry?.proNumber);
          setOwnership({
            entryBy: onHandDelivery?.entryBy?.trim(),
            assignedTo: onHandDelivery?.assignedTo?.trim(),
          });
          setOsdDetails(onHandDelivery);
          setInvestigationStatus(onHandDelivery?.investigationStatusNumber);
          if (
            flag === "investigation" &&
            onHandDelivery?.investigationStatusNumber ===
              EOnHandDeliveryStatus.followupInProgress
          )
            setExpanded((prev) => [...prev, "panel3"]);
          patchEditFormValues(onHandDelivery.entry);
          setPageLoading(false);
        })
        .catch((err: any) => {
          console.error(err);
          setPageLoading(false);
          dispatch(
            PopoutNotification(
              NOTIFICATION_TYPE.ERROR,
              typeof err === "string" ? err : `OS&D # ${osdNumber} not found`,
              Date.now().toString(),
            ),
          );
        });
    }
  };
  const getErrorMessage = (
    error: string,
    touched: boolean,
    className = "form-error",
  ) => {
    if (!error || !touched) return null;
    return <span className={className}>{error}</span>;
  };

  const renderFormErrorMessage = (
    filedName: string,
    className = "form-error",
  ) => {
    if (errors[filedName] && touched[filedName])
      return <span className={className}>{errors[filedName] as string}</span>;
    return null;
  };

  const renderInputFeild = (
    feildName: string,
    label: string,
    placeholder: string = "Enter Details",
    strike: string = "",
    md: number = 3,
    maxLength: number = 150,
    tooltipText: string = "",
    tooltipKey: string = "",
    disabled: boolean = false,
  ) => { /* NOSONAR */
    return (
      <Grid item md={md} xs={12}>
        <FormControl fullWidth size="small">
          {label && (
            <InputLabel style={FORM_STYLES.LABEL} shrink={true}>
              {label} <sup>{strike}</sup>
              &nbsp;
              {tooltipText && (
                <TooltipWithClickAway
                  tooltipText={tooltipText}
                  tooltipKey={tooltipKey}
                />
              )}
            </InputLabel>
          )}
          <TextField
            autoComplete="off"
            id={feildName}
            placeholder={placeholder}
            variant="outlined"
            name={feildName}
            value={values[feildName]}
            onChange={handleChange}
            error={hasErrors(feildName)}
            disabled={disabled || formFieldsDisabled}
            inputProps={{ maxLength: maxLength }}
            onBlur={handleBlur}
          />
        </FormControl>
        {renderFormErrorMessage(feildName)}
      </Grid>
    );
  };

  const renderNumberInputFeild = (
    feildName: string,
    label: string,
    placeholder: string,
    maxLength: number,
    strike: string = "",
    md: number = 3,
    isDisabled: boolean = formFieldsDisabled,
  ) => {
    return (
      <Grid item md={md} xs={12}>
        <FormControl fullWidth size="small">
          {label && (
            <InputLabel style={FORM_STYLES.LABEL} shrink={true}>
              {label} <sup>{strike}</sup>
            </InputLabel>
          )}
          <TextField
            autoComplete="off"
            id={feildName}
            onPaste={handlePaste}
            placeholder={placeholder}
            variant="outlined"
            name={feildName}
            value={values[feildName]}
            onChange={handleChange}
            error={hasErrors(feildName)}
            disabled={isDisabled}
            onBlur={handleBlur}
            type="number"
            onKeyDown={handleKeyDown}
            onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleNumberMaxLength(e, maxLength);
            }}
          />
        </FormControl>
        {renderFormErrorMessage(feildName)}
      </Grid>
    );
  };

  const renderDisabledField = (
    fieldName: string,
    label: string,
    md: number = 3,
    value?: string,
  ) => {
    return (
      <Grid item md={md} xs={12}>
        <FormControl fullWidth size="small">
          <InputLabel
            style={FORM_STYLES.LABEL}
            shrink={true}
            htmlFor={fieldName}
          >
            {label} <sup>&nbsp;</sup>
          </InputLabel>
          <TextField
            autoComplete="off"
            id={fieldName}
            key={fieldName}
            value={value ?? values[fieldName]}
            name={fieldName}
            disabled
            variant="outlined"
          />
        </FormControl>
      </Grid>
    );
  };

  const validatePartyDetails = useCallback(async () => {
    if (!values.partyDetails?.length) return;
    for (let index = 0; index < values.partyDetails.length; index++) {
      const validateFields = ["partyEmail", "partyFax"];
      for (const field of validateFields) {
        await validateField(`partyDetails[${index}].${field}`);
      }
    }
  }, [values.partyDetails, validateField]);

  useEffect(() => {
    if (submitCount < 1) return;
    if (newIndex !== null && values.partyDetails?.[newIndex]) {
      ["partyEmail", "partyFax"].forEach((field) => {
        setFieldTouched(`partyDetails[${newIndex}].${field}`, true, true);
      });
      setNewIndex(null); // Reset
    }
  }, [newIndex, values.partyDetails]);

  const getDamageDetails = async (osdId: number | string) => {
    if (!osdNumber && !osdId) return;

    setPageLoading(true);
    try {
      const damage: IDamage = await GetPartialRefusalAPI(osdId);

      if (!damage) return;

      const fieldMappings: { [key: string]: any } = {
        pieces: damage.pieces,
        proNumber: damage.proNumber,
        weight: damage.weight,
        reporting: damage.reporting,
        lastTrailerNumber: damage.trailer,
        lastManifestNumber: damage.lastManifest,
      };
      validateProCheckD(damage.proNumber);
      Object.entries(fieldMappings).forEach(([key, value]) => {
        if (value) {
          setFieldValue(key, value);
        }
      });

      if (damage.commodity) {
        setFieldValue("commodityCode", damage.commodity);
      }
    } catch (error) {
      console.error("Error fetching damage details:", error);
      // optionally show toast or UI feedback
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (
      terminalWithNameOptions?.length > 0 &&
      osdDetails?.entry?.replyToTerminalNumber
    ) {
      updateInputValue(
        "iTerminal",
        terminalWithNameOptions?.find(
          (d: any) =>
            d?.terminalId?.trim() === osdDetails?.entry?.replyToTerminalNumber,
        ),
      );
      updateInputValue(
        "iInputTerminal",
        osdDetails?.entry?.replyToTerminalNumber,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [terminalWithNameOptions, osdDetails?.entry?.replyToTerminalNumber]);

  useEffect(() => {
    if (exceptionNumber && isEditFormValuePatched) {
      setInitialFormValue(values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditFormValuePatched]);

  useEffect(() => {
    const filteredValues = excludeKeys(values, CHECK_DIGIT_FIELDS);
    const filteredInitialValues = excludeKeys(
      initialFormValue,
      CHECK_DIGIT_FIELDS,
    );
    const hasChanged = !compareObjects(filteredValues, filteredInitialValues);

    setEditFormValueChanged(hasChanged);
    dispatch(isFormValueChanged(hasChanged));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, initialFormValue]);

  useEffect(() => {
    dispatch(isFormValueChanged(false));
    if (exceptionNumber) {
      viewOnHandDeliveryEntry(exceptionNumber);
    }

    if (!terminalOptions?.length) {
      getMasters("terminalMaster");
    }
    if (damageOsdNumber) {
      getDamageDetails(damageOsdNumber);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isSubmitting) return;
    if (Object.keys(errors).length > 0) {
      document.getElementsByName(Object.keys(errors)[0])?.[0]?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitting]);

  const debouncedValidation = useCallback(
    debounce(async () => {
      try {
        const formErrors = await validateForm();
        const proDeliveryInfoErrors = formErrors.partyDetails;

        if (proDeliveryInfoErrors?.length) {
          validatePartyDetails();
          setProInfoAddButtonDisabled(true);
        } else {
          setProInfoAddButtonDisabled(false);
        }
      } catch (error) {
        console.error("Error during form validation:", error);
        setProInfoAddButtonDisabled(true);
      }
    }, 300),

    [validateForm, validatePartyDetails],
  );

  useEffect(() => {
    if (!values) return; // Skip validation if no values
    debouncedValidation();
    return () => debouncedValidation.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, debouncedValidation]);

  return (
    <div className="bg-layout overage-entry">
      {/* header */}
      <PageHeaderWithBack
        osdNumber={osdNumber}
        updatedDateTime={updatedDateTime}
        proNumber={osdDetails?.entry?.proNumber}
        headingTitle="On Hand Delivery"
        damageOsdNumber={damageOsdNumber}
      />
      {/* body */}
      <div className="content-area">
        <Accordion
          className="accordion"
          expanded={expanded.includes("panel1")}
          onChange={handleAccordionChange("panel1")}
        >
          <AccordionSummary
            className="header"
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              className={
                isKnownStatus ? "queue-check queue-check-gc" : "queue-check"
              }
            >
              1
            </Typography>
            <Typography className="accordion-header">On Hand Entry</Typography>
          </AccordionSummary>
          <FormikProvider key={resetTimestamps} value={form}>
            <form action="" onSubmit={handleSubmit}>
              <AccordionDetails className="accordion-container">
                <div id="overageEntry">
                  <Grid container spacing={2} className="filter-margin">
                    <Grid item {...S_GRID_PROPS}>
                      <FormControl fullWidth size="small">
                        <InputLabel
                          style={FORM_STYLES.LABEL}
                          shrink={true}
                          id="TypeLabel"
                        >
                          Type <sup>&nbsp;</sup>
                        </InputLabel>
                        <TextField
                          autoComplete="off"
                          id="type"
                          value={osdDetails?.entry?.exceptionType ?? "OH"}
                          name="origin"
                          disabled
                          variant="outlined"
                        />
                      </FormControl>
                    </Grid>

                    <Grid item {...S_GRID_PROPS}>
                      <FormControl fullWidth size="small">
                        <InputLabel
                          style={FORM_STYLES.LABEL}
                          shrink={true}
                          id="reporting-terminalLabel"
                        >
                          Reporting Terminal <sup>*</sup>
                        </InputLabel>
                        <Autocomplete
                          disablePortal
                          disabled={isSaved()}
                          className="select custom-autocomplete"
                          id="reporting-terminal"
                          size="small"
                          disableClearable={true}
                          value={values?.reporting}
                          options={terminalOptions}
                          getOptionLabel={(option) => option || ""}
                          onChange={(e, value) =>
                            setFieldValue("reporting", value)
                          }
                          noOptionsText={"Records not found"}
                          style={FORM_STYLES.LABEL}
                          popupIcon={
                            <div className="dropdown-icon-group">
                              <ArrowDropUpIcon className="icon-style" />{" "}
                              <ArrowDropDownIcon className="icon-style" />{" "}
                            </div>
                          }
                          renderInput={(params) => (
                            <TextField
                              autoComplete="off"
                              {...params}
                              placeholder="Select Reporting Terminal"
                              variant="outlined"
                              className="dropdown-list"
                              name="reporting"
                              style={FORM_STYLES.LABEL}
                              fullWidth
                              inputProps={{
                                ...params.inputProps,
                                style: { fontSize: "0.9rem" },
                              }}
                            />
                          )}
                        />
                      </FormControl>{" "}
                    </Grid>
                  </Grid>
                  <div>
                    <Grid container spacing={2} className="filter-margin">
                      <Grid item {...S_GRID_PROPS}>
                        <FormControl fullWidth size="small">
                          <InputLabel
                            style={FORM_STYLES.LABEL}
                            shrink={true}
                            id="checkDigitLabel"
                          >
                            PRO# <sup>*</sup>
                          </InputLabel>
                          <TextField
                            autoComplete="off"
                            id="checkDigit"
                            placeholder="Enter Pro Number"
                            variant="outlined"
                            onChange={handleChange}
                            error={Boolean(
                              hasErrors("proNumber") ||
                              proCheckDError /* NOSONAR */,
                            )}
                            disabled={isSaved()}
                            onBlur={(e) => {
                              validateProCheckD(values.proNumber);
                              handleBlur(e);
                            }}
                            value={values.proNumber}
                            name="proNumber"
                            type="number"
                            onPaste={handlePaste}
                            onKeyDown={handleKeyDown}
                            onInput={(
                              e: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                              handleNumberMaxLength(e, 11);
                            }}
                          />
                        </FormControl>
                        {getErrorMessage(
                          errors.proNumber as string,
                          touched.proNumber as boolean,
                        )}

                        {!(errors.proNumber && touched.proNumber) &&
                        proCheckDError ? (
                          <span className="form-error">
                            Enter valid PRO number
                          </span>
                        ) : null}
                      </Grid>
                      {renderDisabledField("origin", "Origin Terminal")}
                      {renderDisabledField(
                        "destination",
                        "Destination Terminal",
                      )}
                      {renderDisabledField(
                        "shipperAccount",
                        "Shipper Account #",
                      )}
                    </Grid>

                    <Grid container spacing={2} className="filter-margin">
                      {renderDisabledField("shipper", " Shipper Name")}
                      {renderDisabledField(
                        "shipperAddress",
                        "Shipper Address",
                        6,
                        [
                          values.shipperAddress,
                          values.shipperCity,
                          values.shipperState,
                          values.shipperZip,
                        ]
                          .filter(Boolean)
                          .join(", "),
                      )}
                    </Grid>
                    <Grid container spacing={2} className="filter-margin">
                      {renderDisabledField("consignee", "Consignee Name")}
                      {renderDisabledField(
                        "consigneeAddress",
                        "Consignee Address",
                        6,
                        [
                          values.consigneeAddress,
                          values.consigneeCity,
                          values.consigneeState,
                          values.consigneeZip,
                        ]
                          .filter(Boolean)
                          .join(", "),
                      )}
                    </Grid>
                    <Grid container spacing={2} className="filter-margin">
                      {renderDisabledField(
                        "thirdPartyName",
                        " 3rd Party/OTH Name",
                      )}
                      {renderDisabledField(
                        "thirdPartyAddress1",
                        "3rd Party/OTH Address",
                        6,
                        [
                          values.thirdPartyAddress1,
                          values.thirdPartyAddress2,
                          values.thirdPartyCity,
                          values.thirdPartyState,
                          values.thirdPartyZip,
                        ]
                          .filter(Boolean)
                          .join(", "),
                      )}
                    </Grid>

                    <Grid container spacing={2} className="filter-margin">
                      {renderDisabledField("ilScac", "I/L SCAC")}

                      {renderNumberInputFeild(
                        "lastManifestNumber",
                        "Last Manifest #",
                        "Enter Last Manifest #",
                        9,
                        "*",
                      )}
                      {renderInputFeild(
                        "lastTrailerNumber",
                        "Last Trailer #",
                        "Enter Last Trailer #",
                        "",
                        3,
                        15,
                      )}
                      {renderNumberInputFeild(
                        "pieces",
                        "Pieces",
                        "Enter Pieces",
                        5,
                        "*",
                      )}
                    </Grid>
                  </div>

                  <Grid container spacing={2} className="filter-margin">
                    {renderNumberInputFeild(
                      "weight",
                      "Weight",
                      "Enter Weight",
                      6,
                      "*",
                    )}
                    <CommodityField
                      id="commodityCode"
                      label="Commodity"
                      key={values.commodityCode}
                      disabled={formFieldsDisabled}
                      value={values.commodityCode}
                      onChange={(_, value) =>
                        setFieldValue("commodityCode", value?.code ?? "")
                      }
                      placeholder="Enter commodity"
                      required
                      onBlur={handleBlur("commodityCode")}
                      error={touched.commodityCode && !!errors.commodityCode}
                      helperText={
                        (errors?.["commodityCode"] &&
                        touched?.["commodityCode"] &&
                        !values.commodityCode
                          ? errors["commodityCode"]
                          : undefined) as string | undefined
                      }
                    />
                    {renderInputFeild(
                      "commodityDescription",
                      "Commodity Description",
                      "Enter Commodity",
                      "*",
                      3,
                      50,
                    )}
                    <Grid
                      item
                      {...S_GRID_PROPS}
                      className="radio-group all-short-entry"
                    >
                      <FormLabel
                        id="storageChargeStartDate"
                        className="mb-10 mt-0"
                      >
                        Storage Charge Date <sup>*</sup>
                      </FormLabel>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          data-testid="delivery-date-picker"
                          open={open}
                          key={dateKey}
                          onOpen={() => !formFieldsDisabled && setOpen(true)}
                          onClose={() => setOpen(false)}
                          value={dayjs(values.storageChargeStartDate ?? null)}
                          name="storageChargeStartDate"
                          onChange={handleDateChange("storageChargeStartDate")}
                          format="MM/DD/YYYY"
                          slotProps={{
                            textField: {
                              error: false,
                              onBlur: (e) => {
                                handleBlur(e);
                              },
                              onClick: () =>
                                !formFieldsDisabled && setOpen(true),
                              inputProps: {
                                readOnly: true,
                                "data-testid": "delivery-date-picker",
                              },
                            },
                          }}
                          disabled={formFieldsDisabled}
                          className="col-md-12"
                        />
                        {getErrorMessage(
                          errors.storageChargeStartDate as string,
                          touched.storageChargeStartDate as boolean,
                        )}
                      </LocalizationProvider>
                    </Grid>
                    <Grid item {...S_GRID_PROPS}>
                      <FormControl className="radio-group value-range">
                        <FormLabel id="valueRangeLabel">
                          Does this shipment have visible damage? <sup>*</sup>
                        </FormLabel>
                        <Grid container spacing={2} className="position-8px">
                          <Grid
                            item
                            {...M_GRID_PROPS}
                            className="float-div form-content-start"
                          >
                            <FormGroup className="shift-left">
                              <RadioGroup
                                row
                                aria-labelledby="isShipmentVisiblyDamaged"
                                name="isShipmentVisiblyDamaged"
                                value={values.isShipmentVisiblyDamaged}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              >
                                <FormControlLabel
                                  value="Y"
                                  disabled={formFieldsDisabled}
                                  control={<Radio />}
                                  label="Yes"
                                  name="isShipmentVisiblyDamaged"
                                  className="mt-0"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  checked={
                                    values.isShipmentVisiblyDamaged === "Y"
                                  }
                                />
                                <FormControlLabel
                                  value="N"
                                  disabled={formFieldsDisabled}
                                  control={<Radio />}
                                  label="No"
                                  name="isShipmentVisiblyDamaged"
                                  className="mt-0"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  checked={
                                    values.isShipmentVisiblyDamaged === "N"
                                  }
                                />
                              </RadioGroup>
                            </FormGroup>
                          </Grid>
                        </Grid>
                      </FormControl>
                      {getErrorMessage(
                        errors.isShipmentVisiblyDamaged as string,
                        touched.isShipmentVisiblyDamaged as boolean,
                        "form-error",
                      )}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} className="filter-margin">
                    <Grid item {...M_GRID_PROPS}>
                      <FormControl
                        fullWidth
                        size="small"
                        className="radio-group value-range"
                      >
                        <FormLabel className="mt-0 mb-10">
                          If Damaged, Please take a picture and note the extent
                          of the damage here? <sup>*</sup>
                          <TooltipWithClickAway
                            tooltipText={"Send pictures to onhand@saia.com"}
                            tooltipKey={"tooltip1"}
                          />
                        </FormLabel>
                        <TextField
                          autoComplete="off"
                          id={"damagePhotoAndNotes"}
                          placeholder={"Enter Damage Details"}
                          variant="outlined"
                          name={"damagePhotoAndNotes"}
                          value={values["damagePhotoAndNotes"]}
                          onChange={handleChange}
                          error={hasErrors("damagePhotoAndNotes")}
                          disabled={formFieldsDisabled}
                          inputProps={{ maxLength: 150 }}
                          onBlur={handleBlur}
                        />
                      </FormControl>
                      {renderFormErrorMessage("damagePhotoAndNotes")}
                    </Grid>
                    {renderInputFeild(
                      "refusalReason",
                      "Please state specific reason for refusal",
                      "Enter refusal for refusal",
                      "*",
                      6,
                    )}
                  </Grid>

                  <Grid container spacing={2} className="filter-margin"></Grid>
                  <h3 className="accordion-content-header">Party Details</h3>
                  <NoteBox message="Note: Notify all parties of the BOL, such as Shipper, Consignee, Third Party, Etc." />
                  <br />
                  <Grid
                    key={formKey}
                    container
                    spacing={2}
                    className="filter-margin"
                  >
                    <FieldArray name="partyDetails">
                      {({ push, remove }) => (
                        <>
                          {(get(values, "partyDetails") ?? []).map(
                            (_d: any, index: number) => (
                              <React.Fragment key={index + ""} /* NOSONAR */>
                                <Grid
                                  container
                                  spacing={2}
                                  className="filter-margin m-0"
                                  data-testid={`party-details-row`}
                                >
                                  <Grid item {...S_GRID_PROPS}>
                                    <FormControl fullWidth size="small">
                                      <InputLabel
                                        style={FORM_STYLES.LABEL}
                                        shrink={true}
                                      >
                                        Party Email - {index + 1} <sup>*</sup>
                                        &nbsp;
                                      </InputLabel>
                                      <TextField
                                        autoComplete="off"
                                        id={`tid-${index}`}
                                        name={`partyDetails[${index}].partyEmail`}
                                        value={get(
                                          values,
                                          `partyDetails[${index}].partyEmail`,
                                          "",
                                        )}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={formFieldsDisabled}
                                        error={hasErrors(
                                          `partyDetails[${index}].partyEmail`,
                                        )}
                                        placeholder="Enter Email"
                                        variant="outlined"
                                        inputProps={{
                                          "data-testid": `party-email-input-${index}`,
                                          maxLength: 50,
                                        }}
                                      />
                                    </FormControl>
                                    {getErrorMessage(
                                      get(
                                        errors,
                                        `partyDetails[${index}].partyEmail`,
                                      ) as string,
                                      get(
                                        touched,
                                        `partyDetails[${index}].partyEmail`,
                                        false,
                                      ) as boolean,
                                    )}
                                  </Grid>

                                  <Grid item {...S_GRID_PROPS}>
                                    <FormControl fullWidth size="small">
                                      <InputLabel
                                        style={FORM_STYLES.LABEL}
                                        shrink={true}
                                      >
                                        Party Fax - {index + 1} <sup></sup>
                                      </InputLabel>
                                      <TextField
                                        autoComplete="off"
                                        id={`partyFax-${index}`}
                                        name={`partyDetails[${index}].partyFax`}
                                        value={get(
                                          values,
                                          `partyDetails[${index}].partyFax`,
                                          "",
                                        )}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={formFieldsDisabled}
                                        error={hasErrors(
                                          `partyDetails[${index}].partyFax`,
                                        )}
                                        placeholder="Enter Fax #"
                                        variant="outlined"
                                        type="number"
                                        onPaste={handlePaste}
                                        onKeyDown={handleKeyDown}
                                        onInput={(
                                          e: React.ChangeEvent<HTMLInputElement>,
                                        ) => {
                                          handleNumberMaxLength(e, 10);
                                        }}
                                      />
                                    </FormControl>
                                  </Grid>
                                </Grid>
                              </React.Fragment>
                            ),
                          )}
                          <Grid item {...XL_GRID_PROPS}>
                            {errors?.partyDetails &&
                              typeof errors.partyDetails === "string" &&
                              getErrorMessage(errors.partyDetails, true)}
                          </Grid>
                          <Grid
                            item
                            {...M_GRID_PROPS}
                            className="btn-group-submit"
                          >
                            {!(
                              formFieldsDisabled ||
                              investigationStatus ===
                                EOnHandDeliveryStatus.needsCleared
                            ) && (
                              <>
                                {values.partyDetails?.length! < 4 && (
                                  <Button
                                    onClick={
                                      proInfoAddButtonDisabled
                                        ? void 0
                                        : async () => {
                                            const nextIndex =
                                              values.partyDetails.length;
                                            push({
                                              partyEmail: "",
                                              partyFax: "",
                                            });
                                            setNewIndex(nextIndex);
                                          }
                                    }
                                    variant="contained"
                                    data-testid="add-party-button"
                                    className={`entry ml ${
                                      proInfoAddButtonDisabled
                                        ? "disable-btn disable"
                                        : ""
                                    }`}
                                  >
                                    Add
                                  </Button>
                                )}
                                {(values.partyDetails?.length ?? 0) > 1 && (
                                  <Button
                                    onClick={() => {
                                      remove(values.partyDetails?.length! - 1);
                                    }}
                                    data-testid="remove-party-button"
                                    variant="contained"
                                    className="clear-btn mr-0 ml"
                                  >
                                    Remove
                                  </Button>
                                )}
                              </>
                            )}
                          </Grid>
                        </>
                      )}
                    </FieldArray>
                  </Grid>

                  <Grid container spacing={2} className="filter-margin"></Grid>
                  <h3 className="accordion-content-header">
                    Please reply to this Address or FAX <sup>*</sup>
                  </h3>

                  <Grid container spacing={2} className="filter-margin">
                    <Grid item {...S_GRID_PROPS}>
                      <FormControl
                        style={{ minWidth: 120 }}
                        fullWidth
                        size="small"
                      >
                        <InputLabel
                          style={FORM_STYLES.LABEL}
                          shrink={true}
                          id="replyToTerminalNumber"
                        >
                          Terminal <sup>*</sup>
                        </InputLabel>
                        <div data-testid="terminal-picker-tooltip">
                          <Autocomplete
                            disabled={formFieldsDisabled}
                            className="custom-autocomplete"
                            noOptionsText="Records not found"
                            disablePortal
                            getOptionLabel={(option) =>
                              `${option.terminalId} -  ${option.terminalName}`
                            }
                            value={inputValues.iTerminal}
                            key={inputValues.iTerminal?.terminalId}
                            inputValue={inputValues.iInputTerminal}
                            onClose={() => {
                              updateInputValue("iInputTerminal", "");
                            }}
                            onInputChange={(e, v) => onAutoInputChange(v)}
                            forcePopupIcon={false}
                            options={terminalWithNameOptions}
                            onChange={(_e, v) => handleAutoCompleteOnChange(v)}
                            disableClearable={true}
                            renderOption={(props, option) => (
                              <li
                                {...props}
                                key={`${option.terminalId?.trim()} - ${option.terminalName.trim()}`}
                                title={`${option.terminalId?.trim()} - ${option.terminalName.trim()}`}
                              >
                                {option.terminalId?.trim()} -{" "}
                                {option.terminalName.trim()}
                              </li>
                            )}
                            filterOptions={(options, { inputValue }) =>
                              options.filter((option) =>
                                option.terminalName
                                  .concat(" ", option?.terminalId ?? "")
                                  ?.toLowerCase()
                                  .includes(inputValue?.toLowerCase()),
                              )
                            }
                            renderInput={(params) => (
                              <TextField
                                autoComplete="off"
                                name="replyToTerminalNumber"
                                placeholder="Enter & Select Terminal"
                                onBlur={handleBlur}
                                error={
                                  hasErrors("replyToTerminalNumber") &&
                                  !values.replyToTerminalNumber
                                }
                                {...params}
                                variant="outlined"
                              />
                            )}
                            renderTags={(value) => (
                              <div
                                className="auto-n-selected-container"
                                title={value.join(", ")}
                              >
                                {value.join(", ")}
                              </div>
                            )}
                          />
                        </div>
                      </FormControl>
                      {getErrorMessage(
                        errors.replyToTerminalNumber as string,
                        (touched.replyToTerminalNumber &&
                          !values.replyToTerminalNumber) as boolean,
                      )}
                    </Grid>

                    {renderNumberInputFeild(
                      "replyToPhoneNumber",
                      "Telephone Number",
                      "Telephone Number",
                      10,
                      "*",
                      3,
                    )}
                    {renderNumberInputFeild(
                      "replyToFaxNumber",
                      "Fax Number",
                      "Fax Number",
                      10,
                      "*",
                      3,
                    )}
                    {renderInputFeild(
                      "replyToAttention",
                      "Attention",
                      "Enter Attention",
                      "*",
                      3,
                      30,
                    )}

                    {renderInputFeild(
                      "replyToAddress1",
                      "Address 1",
                      "Address 1",
                      "",
                      6,
                      30,
                      "",
                      "",
                      true,
                    )}
                    {renderInputFeild(
                      "replyToAddress2",
                      "Address 2",
                      "Address 2",
                      "",
                      6,
                      30,
                      "",
                      "",
                      true,
                    )}
                    {renderInputFeild(
                      "replyToZip",
                      "Zip",
                      "Zip code",
                      "",
                      3,
                      30,
                      "",
                      "",
                      true,
                    )}

                    {renderInputFeild(
                      "replyToCity",
                      "City",
                      "City",
                      "",
                      3,
                      30,
                      "",
                      "",
                      true,
                    )}
                    {renderInputFeild(
                      "replyToState",
                      "State",
                      "State",
                      "",
                      3,
                      6,
                      "",
                      "",
                      true,
                    )}
                  </Grid>
                </div>
                {!osdNumber && !isCleared && (
                  <div className="btn-group-submit">
                    <Button
                      type="button"
                      variant="contained"
                      className="clear-btn mr-0 ml"
                      onClick={() => reset()}
                    >
                      Clear
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      className={"entry ml"}
                    >
                      Generate Notice
                    </Button>
                  </div>
                )}
              </AccordionDetails>
            </form>
          </FormikProvider>
          {shouldShowOnHandResend && (
            // <AccordionDetails className="accordion-container">
            // <h3 className="accordion-content-header">Resend</h3>
            <OnHandResend
              partyEmails={partyEmails}
              key={expanded.includes("panel1").toString()}
              resend={(osdDetails?.resendNotices ?? [])
                .map((item: any) => ({
                  exceptionNumber: item.EXCEPTIONNUMBER,
                  email1: item.email1,
                  email2: item.email2,
                  email3: item.email3,
                  email4: item.email4,
                  reason: item.resendReason,
                }))
                .reverse()}
              onResend={handleOnHandResend}
              resendCount={osdDetails?.resendCount ?? 0}
              canResend={osdDetails?.canResendNotice ?? true}
              isCleared={isCleared || investigationStatus === EOnHandDeliveryStatus.needsCleared}
            />
            // </AccordionDetails>
          )}
        </Accordion>
        {hasOhInvestigationPermission && (
          <Accordion
            className="accordion"
            expanded={expanded.includes("panel2")}
            onChange={handleAccordionChange("panel2")}
          >
            <AccordionSummary
              className="header"
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
            >
              <Typography
                className={
                  [
                    EOnHandDeliveryStatus.needsCleared,
                    EOnHandDeliveryStatus.followupInProgress,
                    EOnHandDeliveryStatus.srpendingpproval,
                  ].includes(investigationStatus as EOnHandDeliveryStatus) ||
                  isCleared
                    ? "queue-check queue-check-gc"
                    : "queue-check"
                }
              >
                2
              </Typography>
              <Typography className="accordion-header">
                On Hand Investigation &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Typography>
            </AccordionSummary>

            <OnHandDeliveryInvestigation
              osdNumber={osdNumber}
              key={expanded.includes("panel2").toString()}
              setInvestigationStatus={setInvestigationStatus}
              osdDetails={osdDetails}
              isEditMode={Boolean(exceptionNumber)}
              isCleared={isCleared}
              onRefresh={() =>
                viewOnHandDeliveryEntry(osdNumber, "investigation")
              }
              entryBy={ownership?.entryBy}
              assignedTo={ownership?.assignedTo}
            />
          </Accordion>
        )}
        {hasOhFollowupPermission && !shouldHideFollowup && (
          <Accordion
            className="accordion"
            expanded={
              expanded.includes("panel3") &&
              ![
                EOnHandDeliveryStatus.exceptionEntry,
                EOnHandDeliveryStatus.creditHold,
                EOnHandDeliveryStatus.inProgress,
              ].includes(investigationStatus as EOnHandDeliveryStatus)
            }
            onChange={handleAccordionChange(
              "panel3",
              [
                EOnHandDeliveryStatus.exceptionEntry,
                EOnHandDeliveryStatus.inProgress,
                EOnHandDeliveryStatus.creditHold,
              ].includes(investigationStatus as EOnHandDeliveryStatus),
            )}
          >
            <AccordionSummary
              className="header"
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3bh-content"
              id="panel3bh-header"
            >
              <Typography
                className={
                  investigationStatus === EOnHandDeliveryStatus.needsCleared ||
                  isCleared
                    ? "queue-check queue-check-gc"
                    : "queue-check"
                }
              >
                3
              </Typography>
              <Typography className="accordion-header">
                On Hand Followup &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </Typography>
            </AccordionSummary>

            <OnHandFollowup
              osdNumber={osdNumber}
              setInvestigationStatus={setInvestigationStatus}
              osdDetails={osdDetails}
              key={expanded.includes("panel3").toString()}
              isEditMode={Boolean(exceptionNumber)}
              isCleared={isCleared}
              onRefresh={() => viewOnHandDeliveryEntry(osdNumber)}
              entryBy={ownership?.entryBy}
              assignedTo={ownership?.assignedTo}
            />
          </Accordion>
        )}
        <Accordion
          className="accordion"
          expanded={expanded.includes("panel4")}
          onChange={handleAccordionChange("panel4")}
        >
          <AccordionSummary
            className="header"
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
          >
            <Typography
              className={
                isCleared ? "queue-check queue-check-gc" : "queue-check"
              }
            >
              {hasOhInvestigationPermission ? (shouldHideFollowup ? 3 : 4) : 2}
            </Typography>
            <Typography className="accordion-header">
              {isCleared && !isPartiallyClearedStatus ? "Cleared Instruction Details" : "Upload Documents"}
            </Typography>
          </AccordionSummary>

          {isCleared && !isPartiallyClearedStatus ? (
            <ClearedInstructionDetails
              clearedInstructionDetails={osdDetails?.clearedInstructionDetails}
            />
          ) : (
            <UploadDocument
              key={expanded.toString() || "upload-document"}
              osdNumber={osdNumber}
              uploadKey={EUploadKey.pro}
            />
          )}
        </Accordion>
        {isPartiallyClearedStatus && (
          <Accordion
            className="accordion"
            expanded={expanded.includes("panel5")}
            onChange={handleAccordionChange("panel5")}
          >
            <AccordionSummary
              className="header"
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel5bh-content"
              id="panel5bh-header"
            >
              <Typography className="queue-check">
                {hasOhInvestigationPermission ? (shouldHideFollowup ? 4 : 5) : 3}
              </Typography>
              <Typography className="accordion-header">
                Cleared Instruction Details
              </Typography>
            </AccordionSummary>
            <ClearedInstructionDetails
              clearedInstructionDetails={osdDetails?.clearedInstructionDetails}
            />
          </Accordion>
        )}
      </div>
      <Loader pageLoader={pageLoading}></Loader>

      <div>
        <Dialog
          open={isOpenPopup}
          aria-labelledby="customized-dialog-title"
          keepMounted
          maxWidth="sm"
          fullWidth={true}
          className="assignment"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="customized-dialog-title"
            className="modal-header"
          >
            Copies to Print
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => setIsOpenPopup(false)}
            sx={{
              position: "absolute",
              right: 15,
              top: 15,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers className="assignment-area">
            <Grid item {...S_GRID_PROPS}>
              <FormControl fullWidth size="small">
                <InputLabel style={FORM_STYLES.LABEL} shrink={true}>
                  Copies to Print if grater than 1 <sup></sup>
                </InputLabel>

                <TextField
                  autoComplete="off"
                  id={"copiesToPrint"}
                  onPaste={handlePaste}
                  placeholder={"Enter copies"}
                  variant="outlined"
                  name={"copiesToPrint"}
                  value={values["copiesToPrint"]}
                  onChange={handleChange}
                  error={hasErrors("copiesToPrint")}
                  disabled={formFieldsDisabled}
                  onBlur={handleBlur}
                  type="number"
                  onKeyDown={handleKeyDown}
                  onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                    handleNumberMaxLength(e, 2);
                  }}
                />
              </FormControl>

              <Button
                onClick={() => {
                  createOnHandEntry();
                }}
                className="entry add-on"
                variant="contained"
              >
                Submit
              </Button>

              <Button
                onClick={() => setIsOpenPopup(false)}
                variant="contained"
                className={"disable"}
              >
                Cancel
              </Button>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}

export default OnHandDeliveryEntry;
